import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import { requireAuthContext } from '../../authorization/GlobalAuthContext'
import JobStatus = com.eidu.sharedlib.entity.job.JobStatus
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

type ExportEntitiesOfTypeParameters = { id: EntityTypeId }

const exportEntitiesOfType = async ({ id }: ExportEntitiesOfTypeParameters): Promise<string> => {
  const authContext = await requireAuthContext()
  return fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/types/${id.toString()}/entities/export`, {
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
      Accept: 'application/json',
    },
  }).then(async (response): Promise<string> => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from entities export endpoint`)

    return JobStatus.fromJsonString(await response.text()).jobId
  })
}

export default exportEntitiesOfType
